import { useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { Link } from "react-router-dom";
import { FiChevronDown, FiGlobe, FiMenu, FiX } from "react-icons/fi";

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Container>
      <TopBar>
        <TopContent>
          <LanguageSwitcher>
            <FiGlobe size={14} />
            <button className="active">PT</button>
            <span>|</span>
            <button>EN</button>
          </LanguageSwitcher>
        </TopContent>
      </TopBar>

      <BottomBar>
        <LogoContainer>
          <Link to="/">
            <img src="/img/logo.png" alt="logo" />
          </Link>
        </LogoContainer>

        {/* Botão Hambúrguer (Apenas Mobile) */}
        <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </MobileMenuButton>

        <Nav isOpen={isMobileMenuOpen}>
          <StyledLink to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</StyledLink>

          {/* DROPDOWN CATÁLOGO */}
          <Dropdown>
            <NavLabel>
              Catálogo <FiChevronDown className="chevron" />
            </NavLabel>
            <DropdownMenu>
              <StyledLink to="/em-breve" onClick={() => setIsMobileMenuOpen(false)}>Ficha Técnica</StyledLink>
              <StyledLink to="/em-breve" onClick={() => setIsMobileMenuOpen(false)}>Comparativo</StyledLink>
              <StyledLink to="/em-breve" onClick={() => setIsMobileMenuOpen(false)}>Tabela Fipe</StyledLink>
              <StyledLink to="/em-breve" onClick={() => setIsMobileMenuOpen(false)}>Mais vendidos</StyledLink>
              <StyledLink to="/em-breve" onClick={() => setIsMobileMenuOpen(false)}>Opinião do leitor</StyledLink>
            </DropdownMenu>
          </Dropdown>

          {/* DROPDOWN FERRAMENTAS */}
          <Dropdown>
            <NavLabel>
              Ferramentas <FiChevronDown className="chevron" />
            </NavLabel>
            <DropdownMenu>
              <StyledLink to="/calculadora-de-combustivel" onClick={() => setIsMobileMenuOpen(false)}>Cálculadora de Combustível</StyledLink>
              <StyledLink to="/comparacao" onClick={() => setIsMobileMenuOpen(false)}>Custo de viagem</StyledLink>
              <StyledLink to="/comparador-de-combustivel" onClick={() => setIsMobileMenuOpen(false)}>Comparador de combustível</StyledLink>
              <StyledLink to="/mais-vendidos" onClick={() => setIsMobileMenuOpen(false)}>Tabela de manutenção</StyledLink>
              <StyledLink to="/em-breve" onClick={() => setIsMobileMenuOpen(false)}>Simulador de financiamento</StyledLink>
            </DropdownMenu>
          </Dropdown>

          <StyledLink to="/noticias" onClick={() => setIsMobileMenuOpen(false)}>Noticias</StyledLink>
          <StyledLink to="/sobre" onClick={() => setIsMobileMenuOpen(false)}>Sobre</StyledLink>
          
          <ContactButton to="/contato" onClick={() => setIsMobileMenuOpen(false)}>Fale Conosco</ContactButton>
        </Nav>
      </BottomBar>

      {/* Overlay para fechar o menu ao clicar fora */}
      {isMobileMenuOpen && <Overlay onClick={() => setIsMobileMenuOpen(false)} />}
    </Container>
  );
}

/* ANIMAÇÕES */
const slideUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

/* ESTILOS BASE */
const Container = styled.header`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const TopBar = styled.div`
  height: 32px;
  background: #000;
  display: flex;
  align-items: center;
  @media (max-width: 768px) { display: none; } /* Esconde o topbar no mobile para economizar espaço */
`;

const TopContent = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  justify-content: flex-end;
`;

const BottomBar = styled.div`
  height: 80px;
  background: rgba(11, 11, 11, 0.98);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  border-bottom: 1px solid rgba(255, 26, 26, 0.2);
  position: relative;
  z-index: 1001;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const LogoContainer = styled.div`
  img { height: 45px; }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  @media (max-width: 992px) {
    display: block;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    right: ${props => (props.isOpen ? "0" : "-100%")};
    width: 280px;
    height: 100vh;
    background: #0f0f0f;
    flex-direction: column;
    padding: 100px 20px 40px;
    transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: -10px 0 30px rgba(0,0,0,0.5);
    align-items: flex-start;
    overflow-y: auto;
  }
`;

/* DROPDOWNS */
const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #151515;
  border-top: 2px solid #ff1a1a;
  border-radius: 0 0 12px 12px;
  padding: 10px 0;
  min-width: 240px;
  display: none;
  flex-direction: column;
  box-shadow: 0 15px 30px rgba(0,0,0,0.5);

  &:before {
    content: "";
    position: absolute;
    top: -15px; 
    left: 0;
    width: 100%;
    height: 15px;
  }

  @media (max-width: 992px) {
    position: static;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0 0 0 15px;
    display: none; /* No mobile, o ideal é abrir com clique, mas manteremos o fluxo */
  }
`;

const Dropdown = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
  padding: 0 15px;

  &:hover ${DropdownMenu} {
    display: flex;
    animation: ${slideUp} 0.2s ease-out forwards;
  }

  @media (max-width: 992px) {
    height: auto;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0;

    &:hover ${DropdownMenu} {
      display: flex;
      animation: none;
    }
  }
`;

const NavLabel = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  @media (max-width: 992px) {
    font-size: 18px;
    padding: 10px 15px;
    width: 100%;
    justify-content: space-between;
  }
`;

const StyledLink = styled(Link)`
  color: #efefef;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  padding: 10px 20px;
  transition: 0.2s;

  &:hover { color: #ff1a1a; }

  @media (max-width: 992px) {
    font-size: 18px;
    padding: 15px;
    width: 100%;
    border-bottom: 1px solid rgba(255,255,255,0.05);
  }
`;

const ContactButton = styled(Link)`
  background: #ff1a1a;
  color: #fff;
  text-decoration: none;
  padding: 10px 22px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  margin-left: 10px;
  text-align: center;

  @media (max-width: 992px) {
    margin: 20px 0;
    width: 100%;
    padding: 15px;
  }
`;

const LanguageSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  button {
    background: none; border: none; color: #666; cursor: pointer;
    &.active { color: #ff1a1a; }
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 1000;
`;